"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _class;

var Slide = (_class =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(Slide, _Activity);

  function Slide() {
    babelHelpers.classCallCheck(this, Slide);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Slide).apply(this, arguments));
  }

  babelHelpers.createClass(Slide, [{
    key: "setup",
    value: function setup() {
      var _this = this;

      this.$().addClass('slide-activity');
      this.addEventListener('startedActivity', this._slidesStarted);
      this.addEventListener('endedActivity', function () {
        return _this.activityComplete();
      });
      this.startActivity();
    }
  }, {
    key: "_doSlideNavigation",
    value: function _doSlideNavigation() {
      var _this2 = this;

      if (document.cookie.indexOf('slide-navigation-found') == -1) {
        document.cookie = "slide-navigation-found=1; expires=".concat(new Date(Date.now() + 86400 * 365 * 1000).toString(), "; path=/");
        setTimeout(function () {
          var e = _this2.$('.slide-body-area aside.controls')[0];

          var nl = e.querySelector('.navigate-left'),
              nr = e.querySelector('.navigate-right');
          var bl = nl.getBoundingClientRect(),
              br = nr.getBoundingClientRect();
          var bc = bl.left + (br.right - bl.left) / 2;
          var p = document.createElement('div');
          p.style.cssText = "position: fixed; top: ".concat(bl.top, "px; left: ").concat(bc, "px; opacity: 0; transform-origin: center bottom;");
          p.innerHTML = "\n\t\t\t\t\t<div style='position: absolute; bottom: 20px; right: -35px; background: #fff; color: #000; font-size: 24px; text-align: center; white-space: nowrap; padding: 10px 20px; border-radius: 5px; box-shadow: #000 1px 1px 8px 2px; text-transform: uppercase;'>\n\t\t\t\t\t\tSlide Navigation\n\t\t\t\t\t</div>\n\t\t\t\t\t<div style='position: absolute; right: -12px; bottom: 10px; border-top: 10px solid #fff; border-left: 12px solid transparent; border-right: 10px solid transparent;'></div>\n\t\t\t\t";
          document.body.appendChild(p);
          setTimeout(function () {
            return p.className = 'slide-tooltip';
          }, 0);
          setTimeout(function () {
            if (p.parentNode) p.parentNode.removeChild(p);
            Reveal.removeEventListener('slidechanged', H, false);
          }, 8000);

          var H = function H() {
            p.className = 'slide-tooltip exit';
            setTimeout(function () {
              if (p.parentNode) p.parentNode.removeChild(p);
            }, 2000);
            Reveal.removeEventListener('slidechanged', H, false);
          };

          Reveal.addEventListener('slidechanged', H, false);
        }, 200);
      }
    }
  }, {
    key: "_bindTooltip",
    value: function _bindTooltip(node, tip) {
      var tt;
      $(node).on('mouseenter', function (event) {
        if (tt) $(tt).remove();
        var e = $(node),
            bl = node.getBoundingClientRect();
        var bc = bl.left + (bl.right - bl.left) / 2;
        var p = document.createElement('div');
        p.style.cssText = "position: fixed; top: ".concat(bl.top, "px; left: ").concat(bc, "px; opacity: 0; transform-origin: center bottom;");
        p.innerHTML = "\n\t\t\t\t<div style='position: absolute; bottom: 20px; left: -20px; background: #fff; color: #000; font-size: 16px; text-align: center; white-space: nowrap; padding: 5px 10px; border-radius: 5px; box-shadow: #000 1px 1px 8px 2px; text-transform: uppercase;'>\n\t\t\t\t\t".concat(tip, "\n\t\t\t\t</div>\n\t\t\t\t<div style='position: absolute; right: -12px; bottom: 10px; border-top: 10px solid #fff; border-left: 12px solid transparent; border-right: 10px solid transparent;'></div>\n\t\t\t");
        document.body.appendChild(p);
        setTimeout(function () {
          return p.style.opacity = 1;
        }, 200);
        tt = p;
      }).on('mouseleave', function (event) {
        if (tt && !$(tt).is('.exit')) {
          tt.className = 'exit';
          tt.style.opacity = 0;
          setTimeout(function () {
            $(tt).remove();
          }, 300);
        }
      });
    }
  }, {
    key: "_setupTranscript",
    value: function _setupTranscript(slide) {
      if (slide.dataset.transcript) {
        if ($(this._transcript).is('.open')) {
          this._transcript.innerHTML = slide.dataset.transcript;
        }

        if (!$('#audio-controls > a#toggle-transcript').length) {
          var x = document.createElement('a');
          x.id = 'toggle-transcript';
          x.style.cssText = 'display: none;';
          x.innerHTML = "<span class='material-icons' data-icon='subject'></span>";
          x.dataset.autoTouch = 'false';
          var tt;
          $('#audio-controls').append(x);
          $(x).on('touchstart click', this._showTranscript);

          this._bindTooltip(x, 'View Transcript');
        }

        $('#toggle-transcript').css('display', '');
      } else {
        $(this._transcript).removeClass('open');
        this._transcript.innerHTML = '';
        $('#toggle-transcript').removeClass('open').css({
          display: 'none'
        });
      }
    }
  }, {
    key: "_showTranscript",
    value: function _showTranscript(event) {
      $(this._transcript).toggleClass('open');
      $(event.target).toggleClass('open', $(this._transcript).is('.open'));
      this._transcript.innerHTML = Reveal.getCurrentSlide().dataset.transcript;
      event.preventDefault();
      return false;
    }
  }, {
    key: "_slidesStarted",
    value: function _slidesStarted(event) {
      var _this3 = this;

      this.$('.slide-body-area').html("<div class=\"activitySlideDeck\"></div>");
      var tgt = this.$().data('thisActivityLink');
      tgt = tgt.split('?');
      if (tgt.length == 1) tgt[1] = 'content=true';else tgt[1] += '&content=true';
      tgt[0] += '/deck';
      $.get(tgt.join('?'), function (rv) {
        rv = JSON.parse(rv);
        var root = document.createElement('div'),
            transcript = document.createElement('div');
        root.className = 'reveal-root';
        root.dataset.autoTouch = 'false';
        root.innerHTML = rv.head;
        transcript.className = 'reveal-transcript';
        _this3._root = root;
        _this3._transcript = transcript;
        var s = $(root).find('link[rel=stylesheet]'),
            loadCount = 0;
        s.on('load error', function (event) {
          loadCount++;

          if (loadCount == s.length) {
            $(root).append(rv.body);
            $(root).parent().trigger('load');

            _this3._doSlideNavigation();

            Reveal.addEventListener('ready', function (event) {
              _this3._setupTranscript(Reveal.getCurrentSlide());
            }, false);
            Reveal.addEventListener('slidechanged', function (event) {
              _this3._setupTranscript(event.currentSlide);
            }, false);
          }
        });

        _this3.$('.slide-body-area .activitySlideDeck').empty().append(transcript).append(root);
      });
      this._slidesMustView = {};
      this.$('.activitySlideDeck').on('load', this._deckLoaded);
    }
  }, {
    key: "_deckLoaded",
    value: function _deckLoaded(_ref) {
      var target = _ref.currentTarget;
      var frame = target;
      var cw;
      if (target.nodeName.toLowerCase() == 'iframe') cw = target.contentWindow;else cw = window;
      this._targetFrame = frame;
      this._targetWindow = cw;

      if (cw.Reveal.isReady()) {
        this._revealReady();
      } else {
        cw.Reveal.addEventListener('ready', this._revealReady);
      }
    }
  }, {
    key: "_revealReady",
    value: function _revealReady() {
      var _this4 = this;

      var items = this._targetWindow.document.querySelectorAll('.reveal .slides > section[data-required]');

      for (var i = 0; i < items.length; i++) {
        this._slidesMustView[items[i].dataset.required] = items[i] == this._targetWindow.Reveal.getCurrentSlide();
      }

      this._targetWindow.Reveal.addEventListener('slidechanged', function (event) {
        var slide = event.currentSlide;
        if (slide.dataset.required) _this4._slidesMustView[slide.dataset.required] = true;

        _this4._updateButtons();
      });

      this._targetWindow.Reveal.addEventListener('enterFullscreen', function (event) {
        var frame = _this4._targetFrame;
        var requestMethod = frame.requestFullscreen || frame.webkitRequestFullscreen || frame.webkitRequestFullScreen || frame.mozRequestFullScreen || frame.msRequestFullScreen;
        if (requestMethod) requestMethod.call(frame);
      });

      this._updateButtons();
    }
  }, {
    key: "_updateButtons",
    value: function _updateButtons() {
      var _this5 = this;

      var itemCount = 0,
          itemViewed = 0;
      itemCount = Object.keys(this._slidesMustView).length;
      itemViewed = Object.keys(this._slidesMustView).map(function (v) {
        return _this5._slidesMustView[v];
      }).length;
      if (itemCount == itemViewed) this.endActivity();
    }
  }]);
  return Slide;
}(_base.default), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "_showTranscript", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_showTranscript"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_slidesStarted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_slidesStarted"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_deckLoaded", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_deckLoaded"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_revealReady", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_revealReady"), _class.prototype)), _class);
exports.default = Slide;